import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";

export const Card = styled(Box)(() => ({
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
  padding: 15,
  display: "flex",
  flexDirection: "column",
  cursor: "pointer",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  height: "100%",
  minHeight: 440,
  maxHeight: 440, // 🔒 prevents card from exceeding 440px
  overflow: "hidden", // hides any content that might overflow
  "&:hover": {
    transform: "scale(1.02)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  },
}));

export const CardImage = styled("img")({
  width: "100%",
  height: 180,
  objectFit: "contain",
  marginBottom: 10,
});

export const Title = styled(Typography)({
  fontWeight: "bold",
  fontSize: 16,
  marginBottom: 4,
  lineHeight: 1.3,
  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  minHeight: "2.6em", // Approximate height for 2 lines (1.3 * 2)
});

export const Subtitle = styled(Typography)({
  fontSize: 13,
  marginBottom: 4,
  color: "#0a66c2",
  display: "flex",
  alignItems: "center",
  gap: 8,
});

export const ConditionBadge = styled("span")({
  background: "#eee",
  padding: "2px 6px",
  borderRadius: 6,
  fontSize: 11,
  color: "#333",
  textTransform: "uppercase",
});

export const SKUText = styled(Typography)({
  fontSize: 12,
  color: "#777",
  marginBottom: 8,
});

export const MetaRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 6,
  marginBottom: 4,
});

export const InfoText = styled("span")({
  fontSize: 13,
  color: "#444",
});

export const Price = styled(Typography)({
  fontSize: 18,
  fontWeight: "bold",
  color: "green",
  margin: "12px 0 6px",
});

export const CardFooter = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "auto",
});

export const LocationPill = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  background: "#f1f1f1",
  borderRadius: 16,
  padding: "6px 10px",
  fontSize: 12,
  color: "#333",
});

export const ButtonBlue = styled(Button)({
  background: "#0052cc",
  color: "#fff",
  borderRadius: 6,
  padding: "6px 12px",
  textTransform: "none",
  "&:hover": { background: "#003f99" },
});
